import { render, staticRenderFns } from "./ExampleTask.vue?vue&type=template&id=080bf0ec&scoped=true"
import script from "./ExampleTask.vue?vue&type=script&lang=js"
export * from "./ExampleTask.vue?vue&type=script&lang=js"
import style0 from "./ExampleTask.vue?vue&type=style&index=0&id=080bf0ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080bf0ec",
  null
  
)

export default component.exports